import React, { HTMLProps } from 'react';

export const ForecastParameterCard: React.FC<
    {
        title?: string;
        leadingElement?: React.ReactNode;
        info?: React.ReactNode;
        inputChanger?: React.ReactNode;
    } & HTMLProps<HTMLDivElement>
> = ({ children, className, title, info, inputChanger, leadingElement, ...rest }) => {
    return (
        <div className={`flex flex-row items-center bg-white shadow-lg rounded-lg py-2 px-2 ${className}`}>
            {!!leadingElement && <div className="mr-2">{leadingElement}</div>}
            <div className="flex shrink flex-1 flex-col">
                <span className="font-xs font-medium text-bnd-black">
                    {!!info ? (
                        <div className="flex flex-row sm:flex-col justify-between items-center sm:items-start">
                            <div className="flex justify-start items-center">
                                {title && <div className="flex shrink">{title}</div>}
                                {info}
                            </div>
                            {!!inputChanger && <div className="">{inputChanger}</div>}
                        </div>
                    ) : (
                        <div className="flex flex-col flex-1 justify-between items-start">
                            {title && <div className="mr-2 sm:mb-0.5 flex shrink-0">{title}</div>}
                            {!!children && <>{children}</>}
                        </div>
                    )}
                </span>
                {!info && !!inputChanger && <div className="">{inputChanger}</div>}
            </div>
        </div>
    );
};
